export default {
      id: "contact-us-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "sprite.svg#contact-us",
      toString: function () {
        return this.url;
      }
    }